var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:headset-16-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 8.616C3 3.85714 7.0302 0 12 0C16.9698 0 21 3.85714 21 8.616V14.7703C21 16.128 19.848 17.2303 18.4278 17.2303H15.8574C15.6882 17.2298 15.5207 17.1976 15.3645 17.1355C15.2083 17.0734 15.0665 16.9827 14.9471 16.8684C14.8278 16.7541 14.7333 16.6185 14.6689 16.4694C14.6046 16.3203 14.5717 16.1606 14.5722 15.9994V11.0777C14.5722 10.3971 15.1482 9.84686 15.8574 9.84686H19.0722V8.616C19.0722 4.87714 15.9042 1.84457 12 1.84457C8.094 1.84457 4.9278 4.87714 4.9278 8.616V9.84686H8.1426C8.8536 9.84686 9.4278 10.3971 9.4278 11.0777V15.9994C9.4278 16.68 8.8518 17.2303 8.1426 17.2303H5.574C5.3508 17.2303 5.136 17.2046 4.9296 17.1531V17.5389C4.9296 19.0046 6.1194 20.2046 7.626 20.3006L7.824 20.3074H9.273C9.47166 19.7693 9.84054 19.303 10.3289 18.9726C10.8172 18.6423 11.401 18.4642 12 18.4629C12.381 18.4635 12.7582 18.5358 13.1099 18.6754C13.4615 18.8151 13.7809 19.0194 14.0495 19.2767C14.3182 19.534 14.531 19.8393 14.6756 20.175C14.8203 20.5107 14.894 20.8703 14.8926 21.2331C14.8926 22.7606 13.5966 24 12 24C10.74 24 9.669 23.2286 9.2712 22.1537H7.824C6.58633 22.1508 5.397 21.6958 4.50115 20.8825C3.60531 20.0692 3.07123 18.9595 3.009 17.7823L3 17.5406V8.616Z",
    fill: "#A4D5F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon_support.c5102702c2248f51ab53bfa63aad9a2e.svg";
export { ForwardRef as ReactComponent };